// Project tasks (/p/:key/tasks): the tasks table scoped to the project, with
// Ticket and Stream columns. `?new`, `?taskId`, `?tab` and `?stream` drive the
// drawers and the stream filter, like the old /tasks page.

import { useNavigate, useSearch } from '@tanstack/react-router'
import { RequireProject } from '../../lib/project-context'
import { TasksView, type TasksSearch } from '../tasks'

export function ProjectTasksPage() {
  const navigate = useNavigate()
  const search = useSearch({ from: '/_authenticated/p/$projectKey/tasks' })
  return (
    <RequireProject>
      {(project) => (
        <TasksView
          project={project}
          search={search}
          onSearchChange={(next: TasksSearch) =>
            void navigate({
              to: '/p/$projectKey/tasks',
              params: { projectKey: project.key },
              search: next,
              // Opening a task is a step in history; closing it is not.
              replace: next.taskId === undefined,
            })
          }
        />
      )}
    </RequireProject>
  )
}
